import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Coins, LogOut } from "lucide-react";
import Ticker from "@/components/Ticker";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <header className="sticky top-0 z-40 border-b border-[#2A2E39] bg-[#0B0E14]/85 backdrop-blur-md">
      <div className="mx-auto flex max-w-[1500px] items-center justify-between px-4 py-3 sm:px-6">
        <div className="flex items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-md border border-[#F0B90B]/30 bg-[#F0B90B]/10">
            <Coins className="h-5 w-5 text-[#F0B90B]" />
          </div>
          <div>
            <div className="font-heading text-sm font-bold tracking-widest text-[#EAECEF]">
              AUREUS <span className="text-[#F0B90B]">GOLD FUND</span>
            </div>
            <div className="text-[10px] uppercase tracking-[0.2em] text-[#5E6673]">
              XAU/USD Managed Trading
            </div>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <span
            data-testid="role-badge"
            className={`rounded px-2 py-1 text-[10px] font-bold tracking-widest ${
              user?.role === "admin"
                ? "bg-[#F0B90B]/10 text-[#F0B90B] border border-[#F0B90B]/40"
                : "bg-[#0ECB81]/10 text-[#0ECB81] border border-[#0ECB81]/40"
            }`}
          >
            {user?.role === "admin" ? "ADMIN" : "CLIENT"}
          </span>
          <div className="hidden text-right sm:block">
            <div className="text-sm font-medium text-[#EAECEF]" data-testid="header-user-name">{user?.name}</div>
            <div className="font-mono text-[10px] text-[#5E6673]">ACC #{user?.account_no}</div>
          </div>
          <button
            data-testid="logout-btn"
            onClick={handleLogout}
            className="flex items-center gap-1.5 rounded-md border border-[#2A2E39] bg-[#1E222D] px-3 py-1.5 text-xs font-medium text-[#EAECEF] transition-colors hover:bg-[#2A2E39]"
          >
            <LogOut className="h-3.5 w-3.5" />
            Logout
          </button>
        </div>
      </div>
      <Ticker />
    </header>
  );
}
